import {UserItemsState} from '@/stores/UserItemsStore/UserItemsStore.types';

import {HttpError} from '@specials/project-user';

import {FrontendError} from '@/services/ErrorService/FrontendError';
import {IUserItemData, IUserItemDataWithBonus} from '@/services/ProjectAuthApi/types';
import {StatefulStore} from '@/stores/StatefulStore';

export class UserItemsStore extends StatefulStore<UserItemsState, HttpError | FrontendError> {
  public setUserItems(userItems: IUserItemData[]): void {
    this.toSuccess({
      userItems,
    });
  }

  public addUserItem(userItem: IUserItemData): void {
    const currentUserItems = this.getUserItems();

    this.toSuccess({
      userItems: [...currentUserItems, userItem],
    });
  }

  public updateUserItem(itemId: string, userItemData: Partial<IUserItemData>): void {
    const currentUserItems = this.getUserItems();

    const newUserItems = currentUserItems.map((userItem) => {
      if (userItem.itemId === itemId) {
        return {
          ...userItem,
          ...userItemData,
        };
      }

      return userItem;
    });

    this.toSuccess({
      userItems: newUserItems,
    });
  }

  public getUserItems = (): IUserItemData[] => {
    try {
      return this.getDataOrFail().userItems;
    } catch (e) {
      return [];
    }
  };

  public getUserItemsWithBonus = (): IUserItemDataWithBonus[] => {
    return this.getUserItems().filter((userItem) => userItem.bonus !== null) as IUserItemDataWithBonus[];
  };
}
